import { ensureTrailingSlash } from '../text';

export function isExternalUrlMatch(url: URL, baseUrl: URL): boolean {
  return !url.href.startsWith(baseUrl.href);
}

function isParamsMatch(
  subjectParams: URLSearchParams,
  targetParams: URLSearchParams,
  exact = false,
) {
  if (exact) {
    const subjectParamsNormalized = new URLSearchParams(subjectParams);
    const targetParamsNormalized = new URLSearchParams(targetParams);
    subjectParamsNormalized.sort();
    targetParamsNormalized.sort();
    return subjectParamsNormalized.toString() === targetParamsNormalized.toString();
  }

  for (const key of subjectParams.keys()) {
    if (!targetParams.has(key) || targetParams.get(key) !== subjectParams.get(key)) return false;
  }
  return true;
}

export function normalizeUrl(url: URL): URL {
  // remove params and ensure trailing slash
  return new URL(`${url.origin}${ensureTrailingSlash(url.pathname)}`);
}

export function isUrlMatch(subjectUrl: URL, targetUrl: URL, matchParams = false): boolean {
  // normalizing ensures that 'https://example.com/foo' doesn't match 'https://example.com/foo-bar'
  const subjectUrlNormalized = normalizeUrl(subjectUrl);
  const targetUrlNormalized = normalizeUrl(targetUrl);

  return (
    targetUrlNormalized.href.startsWith(subjectUrlNormalized.href) &&
    (matchParams ? isParamsMatch(subjectUrl.searchParams, targetUrl.searchParams, false) : true)
  );
}

export function isExactUrlMatch(
  subjectUrl: URL,
  targetUrl: URL,
  matchParams = false,
  exactParams = false,
): boolean {
  const testUrlNormalized = normalizeUrl(subjectUrl);
  const targetUrlNormalized = normalizeUrl(targetUrl);

  return (
    targetUrlNormalized.href === testUrlNormalized.href &&
    (matchParams
      ? isParamsMatch(subjectUrl.searchParams, targetUrl.searchParams, exactParams)
      : true)
  );
}
